export const truncate = (str: string, toLength: number) => {
    if (!str) {
        return "";
    }

    return str.length > toLength ? str.substring(0, toLength - 3) + "..." : str;
};
